import actions from "@/modules/pe-basic-module/data/actions"
import { UPDATE_SINGLE_TYPE } from "@/modules/pe-basic-module/data/actionTypes"
import { Button, ButtonGroup, Popover, Position, Tag } from "@blueprintjs/core"
import { LAND_TYPE } from "@libs/interfaces/layouts"
import { showToast } from "@libs/useful"
import { __ } from "@libs/utilities"
import { ILand } from "../../data/interfaces"

/* Protopia Ecosystem component */
export interface ILandTypeInputProps {
   item: ILand
   className?: string
}
const LandTypeInput = (props: ILandTypeInputProps): JSX.Element => {
    const onChange = (type: string ) => {
        actions(UPDATE_SINGLE_TYPE, {
            data_type: "Land",
            item: {
                land_type: type
            },
            id: props.item.id,
        })
        .then(() => {
            showToast({
                message: __("Element successfully update")
            })
        })
    }
    return <div className={`pe-land-type-input-container ${props.className}`}>
        <Popover
            position={Position.BOTTOM}
            content={ 
                <ButtonGroup fill variant="minimal" vertical >
                    { 
                        Object.values(LAND_TYPE).map(type => <Button alignText="left" onClick={ () => onChange( type.toString() ) } key={type.toString()} >
                            <span className="small letter-spacing-1">
                                {__( type.toString() )}
                            </span>
                        </Button>) 
                    }
                </ButtonGroup>
            }
        >
            <Tag className="small px-3 py-1 pointer hover small letter-spacing-2 " round >
                <span className="small">
                    { __( ( props.item.land_type || "" ).toString() ) }
                </span>
            </Tag>
        </Popover>
    </div>
}
export default LandTypeInput